module.exports = __webpack_public_path__ + "static/media/truck-white.c44c8791.svg";